import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, catchError, map, Observable, of, switchMap, take, tap } from "rxjs";
import { BaseRespone, PaginationResult } from "src/app/models/common.response";
import { environment } from "src/environments/environment";
import { PaginationRequest } from "src/app/models/common.request";
import { BillCharge } from "./ibill-charge";
import { IpdFeatureService } from "src/app/services/ipd-feature.service";


@Injectable({ providedIn: 'root' })
export class BillChargeService {

    private _billCharge: BehaviorSubject<BillCharge | null> = new BehaviorSubject<BillCharge | null>(null);
    private _billCharges: BehaviorSubject<BillCharge[]> = new BehaviorSubject<BillCharge[]>([]);
    private _pagination: BehaviorSubject<PaginationResult | null> = new BehaviorSubject<PaginationResult | null>(null);

    constructor(
        private _httpClient: HttpClient,
        private _ipdFeature: IpdFeatureService
    ) { }

    get billCharge$(): Observable<BillCharge | null> {
        return this._billCharge.asObservable();
    }

    get billCharges$(): Observable<BillCharge[]> {
        return this._billCharges.asObservable();
    }

    get pagination$(): Observable<PaginationResult | null> {
        return this._pagination.asObservable();
    }

    getBillCharge(Billchargedata: PaginationRequest): Observable<BaseRespone<{ pagination: PaginationResult; billCharges: BillCharge[] }>> {
        return this._httpClient.post<BaseRespone<{ pagination: PaginationResult; billCharges: BillCharge[] }>>(`${environment.baseURl}/BillCharge/list`, Billchargedata).pipe(
            tap((response) => {

                this._pagination.next(response.result.pagination);
                this._billCharges.next(response.result.billCharges);
            }),
            catchError((error) => {
                console.error('Error to Fetching data:', error);
                throw error;
            })
        );
    }

    createBillCharge(billcharge: BillCharge): Observable<BaseRespone<BillCharge>> {
        return this._httpClient.post<BaseRespone<BillCharge>>(`${environment.baseURl}/BillCharge`, billcharge)
            .pipe(
                catchError((error) => {
                    return of(error.error);
                }),
                map((newtype) => {
                    // Return the new
                    return newtype;
                }),
                catchError((error) => {
                    console.error('Error to Fetching data:', error);
                    throw error;
                })
            )
    }

    deleteBillCharge(id: number): Observable<BaseRespone<boolean>> {
        return this.billCharges$.pipe(
            take(1),
            switchMap(billcharge =>
                this._httpClient.delete<BaseRespone<boolean>>(`${environment.baseURl}/BillCharge/${id}`).pipe(
                    map((deletedResponse) => {
                        if (deletedResponse.result) {

                            const updated = billcharge.filter(item => item.id !== id);
                            this._billCharges.next(updated);
                        }
                        return deletedResponse;
                    })
                )
            ), catchError((error) => {
                console.error('Error to Fetching data:', error);
                throw error;
            })
        );
    }

    updateBillCharge(billCharge: BillCharge): Observable<BaseRespone<BillCharge>> {
        return this.billCharges$.pipe(
            take(1),
            switchMap(billCharges => this._httpClient.put<BaseRespone<BillCharge>>(`${environment.baseURl}/BillCharge`, billCharge).pipe(
                map((updated: BaseRespone<BillCharge>) => {

                    // Find the index of the updated product
                    const index = billCharges.findIndex(item => item.id === billCharge.id);

                    // Update the product
                    billCharges[index] = billCharge;

                    // Update the products
                    this._billCharges.next(billCharges);

                    // Return the updated product
                    return updated;
                })
            )), catchError((error) => {
                return of(error.error);
            })
        );
    }

    isIPDTabShown(): boolean {
        return this._ipdFeature.isEnabled;
    }
}
